import containerFuild from '../html-snippets/container-fuild';
import buttonPrimary from '../../ui-modules/button-primary/raw-html';
import css from '../tpl-css/style-section-slider-boxer-product.js';

const btnPrimary = buttonPrimary({
  align: 'center',
  text: 'VIEW ALL',
  policy: {
    show: false,
    colPerView: 2,
    alignContent: 'center',
    items: [],
  },
});

const defaultItems = [
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1000a125645130e3c0226.webp',
    name:
      '<h3>Titan Boxer™ Bamboo Leak-Proof Briefs</h3><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>',
    fromText: 'From',
    priceNew: '$120.99',
    priceOld: '$200.00',
    stateProduct: 'Sold out',
    icon: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1008e832406cf8b428f16.png',
    iconText: '<p>Up to 300 ml</p>',
    showIconText: true,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1000a125645130e3c0226.webp',
    name:
      '<h3>Titan Boxer™ Bamboo Leak-Proof Briefs</h3><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>',
    fromText: 'From',
    priceNew: '$120.99',
    priceOld: '$200.00',
    stateProduct: 'Sold out',
    icon: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1008e832406cf8b428f16.png',
    iconText: '<p>Up to 300 ml</p>',
    showIconText: true,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1000a125645130e3c0226.webp',
    name:
      '<h3>Titan Boxer™ Bamboo Leak-Proof Briefs</h3><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>',
    fromText: 'From',
    priceNew: '$120.99',
    priceOld: '$200.00',
    stateProduct: 'Sold out',
    icon: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1008e832406cf8b428f16.png',
    iconText: '<p>Up to 300 ml</p>',
    showIconText: true,
  },
];

const itemsHtml = defaultItems
  .map(
    item => `
      <div class="swiper-slide">
        <a data-attribute="item" href="#" class="wrap-item">
          <div class="wrap-img">
            <img data-attribute="image-item" src="${item.image}" alt="">
          </div>
          <div class="wrap-content-item">
            <div data-attribute="product-name" class="product-name">
              ${item.name}
            </div>
            <div class="wrap-ct-bot">
              <div data-attribute="product-price" class="product-price">
                <div data-attribute="from-text" class="from-text">${item.fromText}</div>
                <div data-attribute="price-new" class="price-new">${item.priceNew}</div>
                <div data-attribute="price-old" class="price-old">${item.priceOld}</div>
                <div data-attribute="state-product" class="state-product">${item.stateProduct}</div>
              </div>

              <div data-attribute="icon-with-text" data-show="${
                item.showIconText ? 'true' : 'false'
              }" class="wrap-icon-with-text" style="display: ${item.showIconText ? 'flex' : 'none'};">
                <div class="wrap-icon">
                  <img data-attribute="icon-item" src="${item.icon}" alt="">
                </div>
                <div data-attribute="text-item" class="wrap-text">
                  ${item.iconText}
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    `,
  )
  .join('');

const html = `
<div data-use-custom-width="true" data-custom-width="1204" class="container" data-attribute="container-content" style="--custom-width: 1204px;">
  <div class="wrap-card">
    <div data-show="true" data-attribute="card-title" class="card-title">
      <h2 style="text-align: center; font-size: 44px">Shop All Products</h2>
      <p style="text-align: center">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
    </div>
    <div class="section-swiper">
      <div class="swiper">
        <div data-attribute="list-item" data-col-per-view="3" data-space-between="16" class="swiper-wrapper">
          ${itemsHtml}
        </div>
      </div>
      <div class="wrap-button-swiper">
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div data-attribute="wrap-btn-dynamic-primary" class="wrap-btn-dynamic-primary">
      ${btnPrimary}
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
